module.exports = __webpack_public_path__ + "static/media/trial2.5bd58a31.mp3";